"use client"

import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { zodResolver } from '@hookform/resolvers/zod';
import { signIn } from 'next-auth/react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState, useTransition } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import * as z from 'zod';
import GithubSignInButton from './github-auth-button';
import { setCookie } from '@/lib/utils';
import request from '@/lib/request'
import { fetchGetUserInfo, login } from '@/app/api/auth';
import { useAuth } from '@/context/AuthContext';

const formSchema = z.object({
  password: z.string(),
  username: z.string()
});

type UserFormValue = z.infer<typeof formSchema>;

export default function UserAuthForm() {
  const { userInfo, setUserInfo, initUserInfo } = useAuth();
  // const searchParams = useSearchParams();
  // const callbackUrl = searchParams.get('callbackUrl');
  const [loading, startTransition] = useTransition();
  const [buttonLoading, setButtonLoading] = useState(false)
  const [username, setUsername] = useState('')
  const router = useRouter();
  const defaultValues = {
    password: '',
    username: ''
  };
  const form = useForm<UserFormValue>({
    resolver: zodResolver(formSchema),
    defaultValues
  });

  const onSubmit = async (data: UserFormValue) => {
    startTransition(() => {
      // signIn('credentials', {
      //   password: data.password,
      //   callbackUrl: callbackUrl ?? '/dashboard'
      // });
      setButtonLoading(true);
      login({
        username: data.username,
        password: data.password
      }).then(async (res) => {
        if (res.code === 200 && res.data) {
          setCookie('token', res.data.token)
          const userInfoResponse = await fetchGetUserInfo();
          if (userInfoResponse.code === 200) {
            setCookie('userInfo', JSON.stringify(userInfoResponse.data))
            // window.location.href = callbackUrl ?? '/dashboard/overview';
            router.push('/dashboard/overview')
          } else {
            // 获取用户信息失败！
            console.error('获取用户信息失败！')
            setUserInfo(initUserInfo)
          }
        } else {
          setButtonLoading(false)
        }
      }).catch(err => {
        console.log(err)
        setButtonLoading(false)
      })

    });
  };

  return (
    <>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="w-full space-y-2"
        >
          <FormField
            name="username"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    type="text"
                    placeholder="请输入用户名"
                    disabled={loading}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    type="password"
                    placeholder="请输入密码"
                    disabled={loading}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button disabled={buttonLoading} className="ml-auto w-full" type="submit" >
            登录
          </Button>
        </form>
      </Form>
      {/*
       <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground">
            Or continue with
          </span>
        </div>
      </div> 
      */}
    </>
  );
}
interface DefaultResponse<T = any> {
  code: number,
  message: string,
  data: T
}